//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import { PERMISSIONS_ROLES } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsItemApp",
    components: {
        membersListInfo
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        hideActions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // eslint-disable-next-line global-require
            defaultImage: require("@/assets/images/appDefault.svg"),
            permissionsRoles: PERMISSIONS_ROLES
        };
    },
    computed: {
        getInheritedGroups() {
            const groupsLength = this.item.groups.length;
            return `${groupsLength} ${this.$t(`appSetPermissions.${groupsLength === 1 ? "group" : "groups"}`)}`;
        },
        tooltipStyle() {
            return "box-shadow: 0px 3px 6px #0000004D; background-color: #ffffff; padding:0";
        }
    },
    methods: {
        openDetails() {
            this.$emit("open");
        },
        itemClicked(event) {
            event.stopPropagation();
        }
    }
};
